import { SelectCompactStub, VStack } from '@direct-frontend/components';
import { LinkWithIcon } from '#shared/components/LinkWithIcon';
import { type ConstructorPageTemplateSelectProps } from './types';

export const ConstructorPageTemplateSelectStub = (props: ConstructorPageTemplateSelectProps) => {
    const { label } = props;

    return (
        <VStack gap="6">
            <SelectCompactStub size="m" color="contour" label={label} isDisabled />
            <LinkWithIcon color="supplementary" isDisabled>
                Показать дизайн этого шаблона в редакторе
            </LinkWithIcon>
        </VStack>
    );
};
